import { useEffect } from 'react'
//import { GetGenderMode } from './../../../utilities/BL/Zones'


const Wait = ({ isActiveWomensMode }) => {
    //const [isActiveWomensMode, setIsActiveWomensMode] = useState(null)


    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")


            // const response = await GetGenderMode()

            // if (response.success) {
            //     setIsActiveWomensMode(response.data.isWomensModeActive)
            // } else {
            //     setIsActiveWomensMode(false)
            // }
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])

    
    return (
        <>
            {/* Encabezado */}
            <div className='Screen__Wait__Background'>
                {/* {isActiveWomensMode ? (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='Screen__Wait__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Varonil.png' className='Screen__Wait__Background__Image' />
                )} */}

                {/* <img src='/img/selfiefan/Fondo-SelfieFan-Varonil.png' className='Screen__Wait__Background__Image' /> */}
                {/* <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='Screen__Wait__Background__Image' /> */}

                <img src='/img/page/backgrounds/background.png' className='Screen__Wait__Background__Image' />
            </div>

            {/* Contenido */}
            <section className="Screen__Wait__Container Container-FullHeight">
                <div className="Screen__Wait__Container__Info">
                    <img src="/img/page/adsl-five.png" className="Screen__Wait__Container__Info__Image" alt="Logo" />
                    <p className="Screen__Wait__Container__Title">PREPÁRATE</p>
                    <p className="Screen__Wait__Container__Text">Estamos por comenzar la dinámica</p>
                </div>
            </section>
            
            {/* Pie de página */}
            <footer className='Screen__Wait__Footer'>
                <p className="text-center FooterCredits">Hecho con ♥ por Five Digital Minds | 2026</p>
            </footer>
        </>
    )
}

export { Wait };





{/* <section className="Screen__Wait__Container Container-FullHeight">
    <div className="Screen__Wait__Container__Lines">
        <div className="Screen__Wait__Container__Lines__Line Screen__Wait__Container__Lines__Line--Red"></div>
        <div className="Screen__Wait__Container__Lines__Line Screen__Wait__Container__Lines__Line--White"></div>
        <div className="Screen__Wait__Container__Lines__Line Screen__Wait__Container__Lines__Line--Red"></div>
        <div className="Screen__Wait__Container__Lines__Line Screen__Wait__Container__Lines__Line--White"></div>
    </div>

    <div className="Screen__Wait__Container__Info">
        {/* <img src="/img/brand/logotipo-adsl.png" className="LogoADSL Screen__Wait__Container__Logo" alt="Logo" /> /}
        <img src="/img/page/adsl-five.png" className="Screen__Wait__Container__Info__Image" alt="Logo" />
        <p className="Screen__Wait__Container__Title">PREPÁRATE</p>
        <p className="Screen__Wait__Container__Text">Estamos por comenzar la dinámica</p>
        {/* <p className="text-right w-100 ms-auto">
            <img src="/img/page/adsl-five.png" className="LogoADSL Screen__Wait__Container__Logo d-block text-right" alt="Logo" />
        </p> /}
        {/* <p className="Welcome__Icon"><i className="bi bi-controller"></i></p> /}
        {/* <p className="Welcome__Icon"><i class="bi bi-file-play"></i></p> /}
        {/* <p className="Welcome__Icon"><i class="bi bi-hourglass-split"></i></p> /}
    </div>
</section>

<footer className='Screen__Wait__Footer'>
    <p className="text-center">Hecho con ♥ por Five Digital Minds | 2026</p>
</footer> */}